import React, { useContext } from 'react'

export const TabContext = React.createContext()

export const useTabs = () => {
  return useContext(TabContext)
}
